export default __webpack_public_path__ + "static/media/SD-divider.7a715d6c.svg";